// Constantes pour le formulaire d'identification d'entreprise

export const LEGAL_FORMS_OHADA = [
  { value: 'GIE', label: 'GIE (Groupement d\'Intérêt Économique)' },
  { value: 'SAAG', label: 'SAAG (Société Anonyme Avec Administrateur Général)' },
  { value: 'SACA', label: 'SACA (Société Anonyme Avec Conseil d\'Administration)' },
  { value: 'SARL', label: 'SARL (Société À Responsabilité Limitée)' },
  { value: 'SARLU', label: 'SARLU (Société À Responsabilité Limitée Unipersonnelle)' },
  { value: 'SAS', label: 'SAS (Société par Actions Simplifiée)' },
  { value: 'SAU', label: 'SAU (Société Anonyme Unipersonnelle)' },
  { value: 'SCS', label: 'SCS (Société en Commandite Simple)' },
  { value: 'SNC', label: 'SNC (Société en Nom Collectif)' },
  { value: 'SP', label: 'SP (Société en Participation)' },
  { value: 'EI', label: 'EI (Entreprise individuelle/Établissement)' },
] as const;

export const COMPANY_TYPES = [
  { value: 'traditional', label: 'Entreprise traditionnelle (PME classique)' },
  { value: 'startup', label: 'Startup (entreprise technologique innovante)' },
] as const;

export const TRADITIONAL_SECTORS = [
  { value: 'agriculture', label: 'Agriculture' },
  { value: 'elevage_agropastoral', label: 'Élevage/Agro-pastoral' },
  { value: 'agro_transformation', label: 'Agro-transformation' },
  { value: 'industrie_legere', label: 'Industrie légère' },
  { value: 'mines_extraction', label: 'Mines et extraction' },
  { value: 'artisanat_metiers', label: 'Artisanat et métiers' },
  { value: 'services_professionnels', label: 'Services professionnels' },
  { value: 'commerce_distribution', label: 'Commerce et distribution' },
  { value: 'transport_logistique', label: 'Transport et logistique' },
  { value: 'construction_btp', label: 'Construction et BTP' },
  { value: 'tourisme_hotellerie', label: 'Tourisme et hôtellerie' },
  { value: 'education_formation', label: 'Éducation et formation' },
  { value: 'sante_services_medicaux', label: 'Santé et services médicaux' },
  { value: 'autres_services', label: 'Autres services' },
] as const;

export const STARTUP_SECTORS = [
  { value: 'fintech', label: 'Fintech (technologies financières)' },
  { value: 'agritech', label: 'Agritech (technologies agricoles)' },
  { value: 'biotech_medtech', label: 'Biotech/Medtech' },
  { value: 'ecommerce_marketplace', label: 'E-commerce/Marketplace' },
  { value: 'edtech', label: 'Edtech (technologies éducatives)' },
  { value: 'cleantech', label: 'Cleantech (technologies vertes)' },
  { value: 'mobilite_transport_intelligent', label: 'Mobilité et transport intelligent' },
  { value: 'blockchain_crypto', label: 'Blockchain et cryptomonnaies' },
  { value: 'ai_machine_learning', label: 'Intelligence artificielle/ML' },
  { value: 'iot', label: 'IoT (Internet des objets)' },
  { value: 'cybersecurite', label: 'Cybersécurité' },
  { value: 'saas', label: 'SaaS (Software as a Service)' },
  { value: 'developpement_applications_mobiles', label: 'Applications mobiles' },
  { value: 'jeux_video_divertissement', label: 'Jeux vidéo et divertissement' },
  { value: 'realite_virtuelle_augmentee', label: 'Réalité virtuelle/augmentée' },
  { value: 'electronique_hardware', label: 'Electronique et hardware' },
  { value: 'robotique_automatisation', label: 'Robotique et automatisation' },
  { value: 'data_analytics_big_data', label: 'Data analytics/Big Data' },
  { value: 'cloud_computing', label: 'Cloud computing' },
  { value: 'autres_technologies_innovantes', label: 'Autres technologies innovantes' },
] as const;

export const TECHNOLOGY_READINESS_LEVELS = [
  { value: 'concept_idee', label: 'Concept/Idée (TRL 1-2)' },
  { value: 'preuve_concept', label: 'Preuve de concept (TRL 3-4)' },
  { value: 'prototype', label: 'Prototype (TRL 5-6)' },
  { value: 'demonstrateur', label: 'Démonstrateur (TRL 7-8)' },
  { value: 'produit_commercial', label: 'Produit commercial (TRL 9)' },
] as const;

export const BUSINESS_MODELS = [
  { value: 'b2b', label: 'B2B (Business to Business)' },
  { value: 'b2c', label: 'B2C (Business to Consumer)' },
  { value: 'b2b2c', label: 'B2B2C (Business to Business to Consumer)' },
  { value: 'marketplace_plateforme', label: 'Marketplace/Plateforme' },
  { value: 'freemium', label: 'Freemium' },
  { value: 'abonnement_saas', label: 'Abonnement/SaaS' },
  { value: 'commission_pourcentage', label: 'Commission/Pourcentage' },
  { value: 'publicite', label: 'Publicité' },
  { value: 'autre', label: 'Autre (préciser)' },
] as const;

export const FINANCING_TYPES = [
  { value: 'pret_bancaire', label: 'Prêt bancaire traditionnel' },
  { value: 'credit_bail', label: 'Crédit-bail/leasing' },
  { value: 'crowdfunding', label: 'Financement participatif/crowdfunding' },
  { value: 'investissement_capital', label: 'Investissement en capital (business angels, VC)' },
  { value: 'subventions', label: 'Subventions/programmes d\'accompagnement' },
  { value: 'financement_public', label: 'Financement public/institutionnel' },
  { value: 'autre', label: 'Autre' },
] as const;

export const EXIT_STRATEGIES = [
  { value: 'ipo', label: 'IPO (introduction en bourse)' },
  { value: 'acquisition', label: 'Acquisition stratégique' },
  { value: 'croissance_organique', label: 'Croissance organique' },
  { value: 'autre', label: 'Autre' },
] as const;

export const YES_NO_OPTIONS = [
  { value: 'oui', label: 'Oui' },
  { value: 'non', label: 'Non' },
] as const;

export const YES_NO_IN_PROGRESS_OPTIONS = [
  { value: 'oui', label: 'Oui' },
  { value: 'non', label: 'Non' },
  { value: 'en_cours', label: 'En cours' },
] as const;

export const CURRENCIES = [
  { value: 'USD', label: 'USD - Dollar américain' },
  { value: 'CDF', label: 'CDF - Franc congolais' },
  { value: 'EUR', label: 'EUR - Euro' },
] as const;

export const COMPANY_SIZES = [
  { value: '1-10', label: '1-10 employés' },
  { value: '11-50', label: '11-50 employés' },
  { value: '51-200', label: '51-200 employés' },
  { value: '201-500', label: '201-500 employés' },
  { value: '501-1000', label: '501-1000 employés' },
  { value: '1000+', label: '1000+ employés' },
] as const;

export const ACCOMPANIMENT_TYPES = [
  { value: 'incubation', label: 'Incubation' },
  { value: 'acceleration', label: 'Accélération' },
] as const;

export const PROPERTY_TYPES = [
  { value: 'proprietaire', label: 'Propriétaire' },
  { value: 'locataire', label: 'Locataire' },
] as const;

// Nationalités africaines (OHADA et autres)
export const NATIONALITIES = [
  // Afrique Centrale (CEMAC)
  { value: 'CD', label: 'Congolaise (RDC)', region: 'Afrique Centrale' },
  { value: 'CG', label: 'Congolaise (République du Congo)', region: 'Afrique Centrale' },
  { value: 'CM', label: 'Camerounaise', region: 'Afrique Centrale' },
  { value: 'GA', label: 'Gabonaise', region: 'Afrique Centrale' },
  { value: 'CF', label: 'Centrafricaine', region: 'Afrique Centrale' },
  { value: 'TD', label: 'Tchadienne', region: 'Afrique Centrale' },
  { value: 'GQ', label: 'Équato-guinéenne', region: 'Afrique Centrale' },
  
  // Afrique de l\'Ouest (UEMOA/CEDEAO)
  { value: 'SN', label: 'Sénégalaise', region: 'Afrique de l\'Ouest' },
  { value: 'CI', label: 'Ivoirienne', region: 'Afrique de l\'Ouest' },
  { value: 'ML', label: 'Malienne', region: 'Afrique de l\'Ouest' },
  { value: 'BF', label: 'Burkinabè', region: 'Afrique de l\'Ouest' },
  { value: 'NE', label: 'Nigérienne', region: 'Afrique de l\'Ouest' },
  { value: 'TG', label: 'Togolaise', region: 'Afrique de l\'Ouest' },
  { value: 'BJ', label: 'Béninoise', region: 'Afrique de l\'Ouest' },
  { value: 'GN', label: 'Guinéenne', region: 'Afrique de l\'Ouest' },
  { value: 'NG', label: 'Nigériane', region: 'Afrique de l\'Ouest' },
  { value: 'GH', label: 'Ghanéenne', region: 'Afrique de l\'Ouest' },
  
  // Afrique de l\'Est
  { value: 'RW', label: 'Rwandaise', region: 'Afrique de l\'Est' },
  { value: 'BI', label: 'Burundaise', region: 'Afrique de l\'Est' },
  { value: 'KE', label: 'Kenyane', region: 'Afrique de l\'Est' },
  { value: 'TZ', label: 'Tanzanienne', region: 'Afrique de l\'Est' },
  { value: 'UG', label: 'Ougandaise', region: 'Afrique de l\'Est' },
  
  // Afrique Australe
  { value: 'AO', label: 'Angolaise', region: 'Afrique Australe' },
  { value: 'ZM', label: 'Zambienne', region: 'Afrique Australe' },
  { value: 'ZA', label: 'Sud-africaine', region: 'Afrique Australe' },
  { value: 'MZ', label: 'Mozambicaine', region: 'Afrique Australe' },
  
  // Afrique du Nord
  { value: 'MA', label: 'Marocaine', region: 'Afrique du Nord' },
  { value: 'DZ', label: 'Algérienne', region: 'Afrique du Nord' },
  { value: 'TN', label: 'Tunisienne', region: 'Afrique du Nord' },
  { value: 'EG', label: 'Égyptienne', region: 'Afrique du Nord' },
  
  // Autres
  { value: 'FR', label: 'Française', region: 'Europe' },
  { value: 'BE', label: 'Belge', region: 'Europe' },
  { value: 'CH', label: 'Suisse', region: 'Europe' },
  { value: 'CN', label: 'Chinoise', region: 'Asie' },
  { value: 'IN', label: 'Indienne', region: 'Asie' },
  { value: 'LB', label: 'Libanaise', region: 'Moyen-Orient' },
  { value: 'US', label: 'Américaine', region: 'Amérique' },
  { value: 'OTHER', label: 'Autre nationalité', region: 'Autre' },
] as const;

// Types de contrat
export const CONTRACT_TYPES = [
  { value: 'CDI', label: 'CDI (Contrat à Durée Indéterminée)' },
  { value: 'CDD', label: 'CDD (Contrat à Durée Déterminée)' },
  { value: 'interim', label: 'Intérim / Mission temporaire' },
  { value: 'stage', label: 'Stage' },
  { value: 'apprentissage', label: 'Contrat d\'apprentissage' },
  { value: 'consultant', label: 'Consultant / Prestataire' },
  { value: 'freelance', label: 'Freelance / Indépendant' },
  { value: 'journalier', label: 'Journalier' },
  { value: 'benevole', label: 'Bénévole' },
  { value: 'autre', label: 'Autre' },
] as const;

// Types utilitaires
export type LegalFormOHADA = typeof LEGAL_FORMS_OHADA[number]['value'];
export type CompanyType = typeof COMPANY_TYPES[number]['value'];
export type TraditionalSector = typeof TRADITIONAL_SECTORS[number]['value'];
export type StartupSector = typeof STARTUP_SECTORS[number]['value'];
export type TechnologyReadinessLevel = typeof TECHNOLOGY_READINESS_LEVELS[number]['value'];
export type BusinessModel = typeof BUSINESS_MODELS[number]['value'];
export type FinancingType = typeof FINANCING_TYPES[number]['value'];
export type ExitStrategy = typeof EXIT_STRATEGIES[number]['value'];
export type Currency = typeof CURRENCIES[number]['value'];
export type CompanySize = typeof COMPANY_SIZES[number]['value'];
export type PropertyType = typeof PROPERTY_TYPES[number]['value'];
export type AccompanimentType = typeof ACCOMPANIMENT_TYPES[number]['value'];
export type Nationality = typeof NATIONALITIES[number]['value'];
export type ContractType = typeof CONTRACT_TYPES[number]['value'];